/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
define([], function() {
    'use strict';

    return {
        or: function(value, defaultValue) {
            return value || defaultValue;
        },

        required: function(value, error) {
            if (value === undefined || value === null) {
                throw new TypeError(error);
            }
            return value;
        }
    };
});



// WEBPACK FOOTER //
// ./rest/utils.js